import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';
import {
  OneClickShippingModeActions,
  OneClickShippingModeActionTypes,
} from '../actions/one-click-shipment-mode.actions';
import { ShippingLocationMode } from '../models/shipping-location-mode.model';

export interface OneClickShippingLocationModeState {
  loading: boolean;
  shippingLocationModesAvailable: ShippingLocationMode[];
  selected: ShippingLocationMode;
}

export const initialState: OneClickShippingLocationModeState = {
  loading: false,
  shippingLocationModesAvailable: [],
  selected: null,
};

export function reducer(
  state = initialState,
  action: OneClickShippingModeActions | OneClickProfileActions,
): OneClickShippingLocationModeState {
  switch (action.type) {
    case OneClickShippingModeActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as OneClickShippingLocationModeState;
    }
    case OneClickShippingModeActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        shippingLocationModesAvailable: action.payload,
      } as OneClickShippingLocationModeState;
    }
    case OneClickShippingModeActionTypes.SELECT: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickShippingLocationModeState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickShippingModeActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
